export function getTimeRange(start: Date | string, end: Date | string): string {
  const startDate = start instanceof Date ? start : new Date(start);
  const endDate = end instanceof Date ? end : new Date(end);
  const opts: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
  return `${startDate.toLocaleTimeString('nl-NL', opts)} - ${endDate.toLocaleTimeString('nl-NL', opts)}`;
}

export function getDayName(date: Date | string): string {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString('nl-NL', { weekday: 'long', day: '2-digit', month: 'short' });
}
